<template>
  <article
    class="person-card"
    :class="{ 'person-card-review': review, 'person-card-ungrouped': ungrouped }"
    @click="open"
    @contextmenu="openContextMenu"
  >
    <b-form-checkbox
      class="person-select"
      :checked="selected"
      @change="$emit('toggle')"
      @click.native.stop
    />
    <div class="person-photo">
      <img v-if="cropUrl" :src="cropUrl" alt="" />
      <span v-else class="person-placeholder"><i class="bi bi-person-fill" /></span>
    </div>
    <div v-if="!ungrouped" class="person-meta">
      <strong>{{ item.name || (item.person && item.person.name) || $t('people_unnamed') }}</strong>
      <span v-if="!review">{{ item.face_count || 1 }} {{ $t('people_photos') }}</span>
    </div>
    <div v-if="review" class="review-actions" @click.stop>
      <PersonAssignmentSelect
        :value="reviewTarget"
        :confirmed-targets="confirmedTargets"
        :draft-targets="draftTargets"
        @input="$emit('set-review-target', $event)"
      />
      <b-button size="sm" variant="primary" :disabled="!reviewTarget" @click="$emit('approve')">
        {{ $t('people_approve') }}
      </b-button>
      <b-button size="sm" variant="outline-light" @click="$emit('ignore')">
        {{ $t('people_ignore_one') }}
      </b-button>
    </div>
  </article>
</template>

<script>
import PersonAssignmentSelect from './PersonAssignmentSelect.vue'

export default {
  components: { PersonAssignmentSelect },
  props: {
    item: { type: Object, required: true },
    review: { type: Boolean, default: false },
    ungrouped: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    confirmedTargets: { type: Array, default: () => [] },
    draftTargets: { type: Array, default: () => [] },
    reviewTarget: { type: [Number, String], default: null },
  },
  computed: {
    cropUrl() {
      if (this.item.crop_url) return this.item.crop_url
      return this.item.representative_face_id
        ? `/control/people/faces/${this.item.representative_face_id}/crop`
        : null
    },
  },
  methods: {
    open() {
      this.$emit(this.review ? 'show-source' : 'open')
    },
    openContextMenu(event) {
      event.preventDefault()
      this.$emit('context', event)
    },
  },
}
</script>

<style>
.person-select.custom-control {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 2.5rem;
  height: 2.5rem;
  min-height: 0;
  margin: 0;
  padding: 0;
}

.person-select .custom-control-label {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.person-select .custom-control-label::before,
.person-select .custom-control-label::after {
  top: 50%;
  left: 50%;
  width: 1.25rem;
  height: 1.25rem;
  transform: translate(-50%, -50%);
}

.person-select .custom-control-label::before {
  box-shadow: 0 1px 5px rgba(0, 0, 0, .8);
}
</style>

<style scoped>
.person-card {
  position: relative;
  display: flex;
  gap: .75rem;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(127, 127, 127, .22);
  border-radius: 12px;
  background: rgba(127, 127, 127, .04);
  cursor: pointer;
  transition: transform .15s ease, border-color .15s ease;
}

.person-card:hover {
  border-color: var(--highlight-color);
  transform: translateY(-2px);
}

.person-photo {
  position: relative;
  aspect-ratio: 1;
  background: rgba(0, 0, 0, .2);
}

.person-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.person-placeholder {
  display: grid;
  width: 100%;
  height: 100%;
  color: var(--faded-text-color);
  font-size: 3rem;
  place-items: center;
}

.person-meta {
  display: grid;
  padding: 0 .75rem;
}

.person-card:not(.person-card-review) .person-meta {
  padding-bottom: .75rem;
}

.person-meta span {
  color: var(--faded-text-color);
  font-size: .8rem;
}

.review-actions {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: .4rem;
  padding: 0 .75rem .75rem;
}

.review-actions .custom-select {
  grid-column: 1 / -1;
  min-width: 0;
}

.review-actions .btn:disabled {
  opacity: var(--disabled-opacity);
}
</style>
